<template>
    <div class="eda-confirm">

        <template v-if="manualConfirmationNeeded">

            <h1 class="eda-confirm__heading">
                {{ $t('confirmUser.unknownDomain') }}

                <eda-link to="/">
                      {{ $t('confirmUser.login') }}
                </eda-link>
            </h1>
        </template>

        <template v-else>
            <h1 class="eda-confirm__heading">
                {{ $t('confirmUser.emailSent') }}
            </h1>

            <div class="eda-confirm__code">
                <eda-security-code title="Skriv koden her" v-model="confirmationCode"></eda-security-code>
            </div>

            <div calss="eda-confirm__submit" :class="{'eda-confirm__submit--error': error}">
                <eda-button @click="confirmUser()" :loading="loading" :disabled="confirmationCode.length != 6">
                    {{ $t('confirmUser.confirm') }}
                </eda-button>
            </div>

        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import EdaLink from '../components/vLink';
    import EdaInput from '../components/vInput';
    import EdaEllipsis from "../components/vEllipsisLoader";
    import EdaSecurityCode from '../components/vSecurityCodeInput';
    import EdaButton from '../components/vButton';
    import axios from 'axios';
    import apiMixin from '../mixins/apiMixin';


    export default {
        name: "eda-confirm",
        components: {
            EdaLink,
            EdaInput,
            EdaButton,
            EdaSecurityCode
        },
        mixins: [
            apiMixin.apiMixin
        ],
        props: {
            hash: {type: String, default: ""},
        },
        data: function () {
            return {
                error: false,
                manualConfirmationNeeded: false,
                confirmationCode: "",
                errorMessage: "",
                loading: false,
            }
        },

        methods: {
            ...mapActions(["setUser"]),



            confirmUser() {
                var that = this;
                that.error = false;
                that.loading = true;
                axios.post(process.env.VUE_APP_API_URL + "/users/confirm/" + that.hash, {
                    "confirmationCode": that.confirmationCode,
                }, that.apiHeaders).then(function (response) {

                    if (response.status == 200) {
                        that.setUser(response.data);
                        that.$router.push({path: '/user/retailer'});
                    }
                    if (response.status == 202) {
                        that.manualConfirmationNeeded = true;
                    }

                }).catch(function (error) {
                    that.error = true;
                    that.errorMessage = error.response.data.error.message;
                    console.log(error.response)
                }).finally(function () {
                    that.loading = false;
                });
            }
        }
    }

</script>

<style>

    .eda-confirm__heading {
        font-size: 1.3em;
        max-width: 20em;
        display: block;
        font-weight: 600;
    }

    .eda-confirm {
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 1.1em;
        min-height: 60vh;
        color: white;
    }

    .eda-confirm__code {
        padding-bottom: 2em;
    }

    .eda-confirm__password,
    .eda-confirm__username,
    .eda-confirm__submit {
        padding: 0.5em;
        max-width: 20em;
        width: 100%;
    }

    .eda-confirm__submit {
        padding-top: 1.5em;
        display: flex;
        justify-content: center;
        padding-bottom: 1em;
    }

    .eda-confirm__submit--error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .eda-confirm__form-element {
        padding: 1em 2em;
        width: 100%;
        border-radius: 3em;
        border: none;
        outline: none;
        font-weight: 600;
    }

    .eda-confirm__input {
        color: white;
        background-color: #0E1A10;

    }

    .eda-confirm__button {
        text-align: center;
        color: white;
        font-size: 1em;
        background-color: #00B27C;
    }

    .eda-confirm__recover {
        width: 100%;
        max-width: 20em;
        padding: 0.5em 2em 2em 2em;
        text-align: left;
    }

    .eda-confirm__forgot {
        font-size: 0.8em;
    }

    .eda-confirm__login {
        padding-top: 1.2em;
        font-size: 0.8em;
    }

    .eda-confirm__login-link {
        padding-left: 0.75em;
    }

    .eda-confirm__link {
        color: #00B27C;
        font-weight: 300;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

</style>